<script>
export default {
  data () {
    return {
    }
  },

  computed: {
  },

  methods: {
  },

  created () {
  }
}

</script>

<template>
  <main class=" column items-center justify-center">
    NOT AUTHORIZED
  </main>
</template>

<style scoped lang="scss">
main.not-authorized {
  flex: 1;
}
</style>